module.exports = __webpack_public_path__ + "img/MadMix.56187f43.png";